function applyCursor(value) {
    return { cursor: value };
}
export function applyCursorDefault() {
    return applyCursor("default");
}
export function applyCursorDisabled() {
    return applyCursor("not-allowed !important");
}
export function applyCursorPointer() {
    return applyCursor("pointer");
}
